module.exports = __webpack_public_path__ + "img/boabet-red.c1ac4f76.png";